// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAs5Mzw9r2jzvF1Qi9rWqTcr2TUgEdsLUA",
  authDomain: "heygerman-74bef.firebaseapp.com",
  projectId: "heygerman-74bef",
  storageBucket: "heygerman-74bef.firebasestorage.app",
  messagingSenderId: "307880546038",
  appId: "1:307880546038:web:93066f6d32411ad98a26d7",
  measurementId: "G-FVYJXHJDL1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Export the services for use in other parts of the app
export { db, auth, analytics };
export default app;